<app-dialog
  [headerLabel]="'LABEL.SEND_RECEIPT' | translate"
  [dialogType]="dialogType"
  [hideCloseButton]="true"
  [primaryActionText]="'ACTION.SEND' | translate"
  [secondaryActionText]="'ACTION.CANCEL' | translate"
  [trackingObject]="trackingObject"
  [trackingScreenName]="trackingScreenName"
  [primaryActionTapped]="sendReceiptTapped"
  [secondaryActionTapped]="cancelTapped"
  (onPrimaryAction)="sendReceipt()"
  (onSecondaryAction)="onCancel.emit()"
  (onDialogClose)="clearToast()"
>
  <div class="send-receipt-dialog">
    <p class="description" [innerHTML]="description | safe: 'html'"></p>

    <button
      type="button"
      class="preview-receipt"
      trackable
      [trackingObject]="trackingObject"
      [trackingAction]="sendPreviewTapped"
      (click)="previewReceipt()"
    >
      {{ 'ACTION.PREVIEW_RECEIPT' | translate }}
    </button>
  </div>
</app-dialog>
